import { GameConfig } from "../config";
import { InvaderKind, InvaderSeed, BunkerSeed } from "../types";

/** The classic rectangular fleet: one banded rank of invaders per row. */
export function gridSwarmSeeds(level: number, cfg: GameConfig): InvaderSeed[] {
  const { rows, cols, invaderWidth, invaderHeight, hGap, vGap, marginTop, levelDrop } =
    cfg.swarm;
  const swarmWidth = cols * invaderWidth + (cols - 1) * hGap;
  const startX = (cfg.canvas.width - swarmWidth) / 2;
  const dropOffset = Math.min(level - 1, 4) * levelDrop;
  const seeds: InvaderSeed[] = [];

  for (let r = 0; r < rows; r++) {
    const kind: InvaderKind = r === 0 ? "top" : r < 3 ? "mid" : "bottom";
    for (let c = 0; c < cols; c++) {
      seeds.push({
        x: startX + c * (invaderWidth + hGap),
        y: marginTop + dropOffset + r * (invaderHeight + vGap),
        kind,
      });
    }
  }
  return seeds;
}

/** `count` identical bunkers spread evenly across the canvas. */
export function rowBunkerSeeds(cfg: GameConfig): BunkerSeed[] {
  const { count, cols, blockSize, y, shape } = cfg.bunker;
  const bunkerWidth = cols * blockSize;
  const gap = (cfg.canvas.width - count * bunkerWidth) / (count + 1);

  return Array.from({ length: count }, (_, i) => ({
    x: gap + i * (bunkerWidth + gap),
    y,
    shape,
    blockSize,
  }));
}
